module.exports = __webpack_public_path__ + "img/saizi1.162b89a4.png";